var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import { Component, createRef } from "react";
const MousePositionHOC = () => (InnerComponent) => class MousePosition extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      x: 0,
      y: 0
    });
    __publicField(this, "container", createRef());
    __publicField(this, "onMouseMove", ({
      clientX,
      clientY
    }) => {
      var _a;
      const bbox = (_a = this.container) == null ? void 0 : _a.current.getBoundingClientRect();
      this.setState({
        x: clientX - bbox.left,
        y: clientY - bbox.top
      });
    });
  }
  render() {
    const {
      x,
      y
    } = this.state;
    return /* @__PURE__ */ jsx("div", { ref: this.container, onMouseMove: this.onMouseMove, children: /* @__PURE__ */ jsx(InnerComponent, { ...this.props, mouseX: x, mouseY: y }) });
  }
};
export {
  MousePositionHOC as default
};
